var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4F7F\u7528\u624B\u518C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.6194822%",
    y1: "28.9895246%",
    x2: "63.4804345%",
    y2: "48.2195682%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B93FC",
    offset: "19.1206531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6784FB",
    offset: "33.3722457%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7891FC",
    offset: "48.5684682%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3B4FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.3342505%",
    y1: "46.914933%",
    x2: "40.5913869%",
    y2: "62.4094024%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061863",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#445AB5",
    offset: "49.2119795%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E89FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "21.1858297%",
    x2: "78.6933834%",
    y2: "73.0212557%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8C1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8C1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8C1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8C1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3553C6",
    offset: "26.1946257%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C4AB2",
    offset: "47.8892033%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001982",
    offset: "61.8266113%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1933A4",
    offset: "80.3928389%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E7DFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.8371324,4.37352656 C1.8371324,5.83136874 2.33431399,8.01813202 3.32867716,10.9338164 C4.82022193,15.3073429 5.56599431,17.4941062 7.05753908,18.2230273 C8.54908384,18.9519484 19.7356696,15.3073429 19.7356696,12.3916586 C17.4983524,10.9338164 9.29485623,10.2048953 7.05753908,6.56028984 C5.56599431,4.13055286 3.82585875,3.40163177 1.8371324,4.37352656 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.3%",
    y: "-38.3%",
    width: "172.6%",
    height: "190.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.134143227   0 0 0 0 0.663263736  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.6462527%",
    y1: "21.8570167%",
    x2: "84.2901628%",
    y2: "74.8128255%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE1FF",
    offset: "75.3849185%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3C2FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.5056693%",
    y1: "-1.42108547e-12%",
    x2: "36.0259233%",
    y2: "86.5426151%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C5CF5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C59E1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F7F\\u7528\\u624B\\u518C",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-circle-o\\u5907\\u4EFD",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(2.000000, 1.994828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(0.000000, 1.687837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5321734,2.18676328 C12.029355,0.728921093 11.7807642,0 10.786401,0 C9.29485623,0 1.8371324,1.45784219 1.09136001,2.18676328 C0.345587632,2.91568437 3.32867716,6.56028984 4.07444955,5.83136874 C4.57163113,5.34542135 7.05753908,4.13055286 11.5321734,2.18676328 Z",
    id: "\\u8DEF\\u5F84-7",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8371324,4.37352656 C1.8371324,1.94378958 1.33995081,1.45784219 0.345587632,2.91568437 C-1.14595713,5.10244765 2.58290478,15.3073429 4.07444955,16.036264 C5.06881272,16.5222114 5.81458511,15.7932903 6.31176669,13.8495008 L1.8371324,4.37352656 Z",
    id: "\\u8DEF\\u5F84-5",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.8371324,4.37352656 C1.8371324,3.64460546 10.0406286,0.728921093 11.5321734,1.45784219 C13.0237181,2.18676328 17.7081385,10.9016431 19.7356696,11.6627375 C21.7632007,12.4238319 11.5321734,16.7651851 9.29485623,16.036264 C7.05753908,15.3073429 1.8371324,5.10244765 1.8371324,4.37352656 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29485623,6.56028984 L10.0406286,7.65367147 L6.31176669,8.74705311 L5.56599431,7.65367147 L9.29485623,6.56028984 Z M10.786401,3.64460546 L11.5321734,4.81087921 L4.82022193,6.56028984 L4.07444955,5.39401609 L10.786401,3.64460546 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#B9C6FF",
    opacity: 0.600000024
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.8552687,10.4282141 C14.4733275,10.4282141 14.9739273,10.9175024 14.9739273,11.5215958 C14.9739273,12.1256891 14.4733275,12.6149774 13.8552687,12.6149774 C13.2372098,12.6149774 12.7366101,12.1256891 12.7366101,11.5215958 C12.7366101,10.9175024 13.2372098,10.4282141 13.8552687,10.4282141 Z M14.8465041,0.2177084 C16.9058947,0.2177084 19.0944985,1.75091977 19.0944985,3.58331618 C19.0944985,4.80491379 18.0280491,5.99733067 15.8951504,7.16056683 L15.8739647,7.17745101 C15.5531292,7.43314443 15.3660765,7.82093618 15.3656864,8.23119754 L15.3656366,8.2836004 L15.3656366,8.2836004 C15.3652994,8.74169948 14.8628568,9.18817524 14.3480085,9.18790739 C13.8331602,9.1875753 13.4079203,8.8469116 13.3409056,8.40520591 L13.3317123,8.28241536 L13.332124,7.72302375 C13.3329438,7.13116203 13.5547776,6.56094306 13.9556425,6.12549798 C15.4229406,4.52341303 15.7640265,3.3769863 14.9789001,2.6862178 C13.7140331,1.45026928 13.7819646,3.98515705 11.7150823,3.97331395 C10.9627264,3.98181117 10.4502153,3.23710999 10.4502153,2.73736543 C10.4502153,0.904967486 12.7871092,0.2177084 14.8465041,0.2177084 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    transform: "translate(14.772357, 6.416343) rotate(3.000000) translate(-14.772357, -6.416343) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceManual);
export default __webpack_public_path__ + "static/media/service-manual.a059f00d8ab396bb4743fbb987aa32c5.svg";
export { ForwardRef as ReactComponent };